import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-6 py-3" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-5 text-sm text-gray-900" }
const _hoisted_7 = { class: "overflow-hidden line-clamp-1" }
const _hoisted_8 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import StatusPill from '@/components/StatusPill.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import { useRouter } from 'vue-router';
import { ref, onMounted, computed, watch } from 'vue';
import throttle from "lodash/throttle";
import voucher from "@/classes/Voucher";
import { paginatePage } from '@/helpers/PageHelper';
import { MaxUsageType } from '@/enums/MaxUsageType';
import { ValidityRangeType } from '@/enums/ValidityRangeType';

import { formatDateTime, formatDate } from '@/helpers/TimeFormatter'

/**
 * ********************************
 * Data 
 * ********************************
 */
 
export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router           = useRouter();
 const loader           = ref(false);
 const showError        = ref(false);
 const errorMsg         = ref(null);
 const showSuccess      = ref(false);
//  const illnessId        = ref(route.params.id)
 const mainRoute        = ref(`/vouchers`);
 const currentRoutePath = computed(() => router.currentRoute.value.path);


const getStatus = (status: number) => {
    let color = 'yellow';
    let text = 'Unknown';

    switch (status) {
        case 1:
            color = 'violet';
            text = 'Scheduled';
            break;
        case 2:
            color = 'yellow';
            text = 'Ongoing';
            break;
        case 3:
            color = 'red';
            text = 'Expired';
            break;
        case 4:
            color = 'red';
            text = 'Cancelled';
            break;
    }

    return { color, text };
}

/**
 * ********************************
 * Page Renderer Data 
 * ********************************
 */
 const items           = ref(null);
const filterDate       = ref(null);
const tabCount    = ref(0);
const log_counts      = ref(0);
const logs            = ref({});


/**
 * ********************************
 * query 
 * ********************************
 */
const searchText = ref('');
const activeTab  = ref();
const goToPage   = ref();
const tab   = ref('all');

// Tabs
const tabs: { name: string, count: number, allowed: boolean }[] = computed(() => [
    {
        name: 'All',
        count: tabCount.value,
        href: mainRoute.value,
        allowed: true
    },
    {
        name: 'Scheduled',
        count: tabCount.value,
        href: `${mainRoute.value}/scheduled`,
        allowed: true
    },
    {
        name: 'Ongoing',
        count: tabCount.value,
        href: `${mainRoute.value}/ongoing`,
        allowed: true
    },
    {
        name: 'Expired',
        count: tabCount.value,
        href: `${mainRoute.value}/expired`,
        allowed: true
    },
    {
        name: 'Cancelled',
        count: tabCount.value,
        href: `${mainRoute.value}/cancelled`,
        allowed: true
    },
    {
        name: 'Activity Logs',
        count: log_counts.value,
        href: `${mainRoute.value}/logs`,
        allowed:
            window.$hasPermission('view-activity-logs')
    }
]);

// Headers
const headers: { text: string }[] = [
    { text: 'VOUCHER NAME' },
    { text: 'VOUCHER CODE' },
    { text: 'INFORMATION' },
    { text: 'USAGES' },
    { text: 'VALIDITY RANGE' },
    { text: 'STATUS'},
    { text: 'CREATED AT'}
];

/**
 * ********************************
 * Methods
 * ********************************
 */

const indexVoucher = async (data: string) => {
    try {
        loader.value = true;
        const queryString = searchText.value ? `&query=${searchText.value}` : 'query';
        const dateQuery = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const goToPageValue = paginatePage(data);
        let tabValue = tab.value;
        
        switch (currentRoutePath.value) {
            case '/vouchers/all':
                tabValue = 'all';
                break;
            case '/vouchers/scheduled':
                tabValue = 'scheduled';
                break;
            case '/vouchers/ongoing':
                tabValue = 'ongoing';
                break;
            case '/vouchers/expired':
                tabValue = 'expired';
                break;
            case '/vouchers/cancelled':
                tabValue = 'cancelled';
                break;
            case '/vouchers/logs':
                tabValue = 'all';
                break;
            default:
                tabValue = 'all'; // Default fallback
        }
        
        const response = await voucher.indexVoucher(`${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}`)
        
        items.value = response?.data.items;
        logs.value = response?.data.logs;
        // ... handle other response data ...
    }
    catch(error) {
        showError.value = true;
        errorMsg.value = error.response.data.message;
            
        if(error?.response?.status == 401) {
            window.location.replace('/login');
        }
    }
    finally {
        loader.value = false;
    }
}

const exportVoucher = async () => {
    try {
        loader.value = true;
        const params = currentRoutePath.value === '/vouchers' ? '' : '';

        await voucher.exportVoucher(params);
        showSuccess.value = true;
    } catch (error: any) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const applyFilters = () => {
    indexVoucher(goToPage.value);
}


const searchData = (val: string) => {
    searchText.value = val
}

watch(
    searchText,
    throttle(() => {
        indexVoucher(goToPage.value);
    }, 1000)
);

watch(
    filterDate,
    () => {
        indexVoucher(goToPage.value);
    }
);

onMounted(() => {
    indexVoucher(goToPage.value);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Vouchers" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs.value,
          "button-items": true
        }, {
          buttons: _withCtx(() => [
            _createVNode(ButtonComponent, {
              class: "text-gray-900",
              secondary: "",
              exportBtn: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (exportVoucher())),
              disabled: loader.value
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Export ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (_ctx.$hasPermission('create-vouchers'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  createBtn: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(`/vouchers/create`)))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Create ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          search: searchText.value,
          onFetchData: searchData,
          "text-filters": currentRoutePath.value !== '/vouchers/logs',
          "onUpdate:filters": applyFilters,
          "custom-filters": activeTab.value !== 'activity_logs'
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DatePicker, {
                id: "filterDate",
                name: "filterDate",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: filterDate.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterDate).value = $event)),
                placeholder: "Start Date & End Date",
                label: "Start Date & End Date"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["search", "text-filters", "custom-filters"])
      ]),
      (currentRoutePath.value !== '/vouchers/logs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(DataTable, {
              headers: headers,
              count: items.value?.data.length
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(item.code), 1),
                    _createElementVNode("td", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(item.description ?? '--'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.max_usage_type == _unref(MaxUsageType).LIMITED ? `${item.usage_count ?? 0} / ${item.max_usage_count}` : item.usage_count ?? 0), 1),
                    _createElementVNode("td", _hoisted_9, [
                      (item.validity_range_type == _unref(ValidityRangeType).ANYTIME)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" Anytime ")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_unref(formatDate)(item.start_at, 'ASIA/MANILA')) + " - " + _toDisplayString(_unref(formatDate)(item.end_at, 'ASIA/MANILA')), 1)
                          ], 64))
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass(["px-6 py-5 text-sm whitespace-nowrap", `text-${getStatus(item.status).color}-600`])
                    }, [
                      _createVNode(StatusPill, {
                        color: getStatus(item.status)?.color,
                        text: getStatus(item.status)?.text
                      }, null, 8, ["color", "text"])
                    ], 2),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(`${_unref(formatDateTime)(item.created_at, 'ASIA/MANILA')}`), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createVNode(ActionButton, {
                        "edit-btn": "",
                        onClick: ($event: any) => (_unref(router).push(`/vouchers/show/${item.id}`))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"]),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value,
              onNextPage: indexVoucher
            }, null, 8, ["items"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(ActivityLogsTable, { logs: logs.value }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Vouchers Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})